import { render, staticRenderFns } from "./registrations-type.vue?vue&type=template&id=1f3e5916&scoped=true&"
import script from "./registrations-type.vue?vue&type=script&lang=js&"
export * from "./registrations-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3e5916",
  null
  
)

export default component.exports